const spacing = (count) => {
    return `${count * 8}px`
}

export { spacing }
